import { render, staticRenderFns } from "./GeometryEditor.vue?vue&type=template&id=4286b5ae&lang=pug&"
import script from "./GeometryEditor.vue?vue&type=script&lang=js&"
export * from "./GeometryEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports